import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { SiteHeader } from './SiteHeader';

/**
 * Shared wrapper for the Privacy + Terms pages. Sticky brand header,
 * single-column readable column, last-updated footer, and a CTA at the
 * bottom so visitors who land here directly still have a way to start.
 */
export function LegalLayout({
  title,
  lastUpdated,
  children,
}: {
  title: string;
  lastUpdated: string;
  children: ReactNode;
}) {
  return (
    <div className="min-h-screen bg-white text-slate-900">
      <SiteHeader />

      <main className="mx-auto max-w-3xl px-6 py-12 sm:py-16">
        <Link to="/" className="text-sm text-brand-700 hover:underline">
          ← Back to home
        </Link>
        <h1 className="mt-3 text-3xl font-semibold tracking-tight sm:text-4xl">{title}</h1>
        <p className="mt-2 text-sm text-slate-500">Last updated: {lastUpdated}</p>

        <div className="legal-content mt-8">{children}</div>

        <div className="mt-16 border-t border-slate-200 pt-8 text-sm text-slate-500">
          Questions? Email{' '}
          <a href="mailto:contact.dormantfiling@gmail.com" className="text-brand-700 hover:underline">
            contact.dormantfiling@gmail.com
          </a>
          .
        </div>
      </main>
    </div>
  );
}
